// Generated by bench/rank.mjs from holidays-274.json, coco-216.json.
// Do not edit by hand; re-run the benchmark (bench/README.md) and this script.

import type { ModelVariant, ProjectionMethod } from './types'

/** Best first by image-similarity quality. Unbenchmarked models go last. */
export const MODEL_RANK: readonly ModelVariant[] = [
  'embeddinggemma2', // avg rank 2.00: holidays-274 mAP 0.933, coco-216 mAP 0.564, NMI 0.790
  'chrome-ai', // avg rank 2.00: holidays-274 mAP 0.744, coco-216 mAP 0.649, NMI 0.833
  'nomic', // avg rank 2.33: holidays-274 mAP 0.911, coco-216 mAP 0.560, NMI 0.797
  'smolvlm2-vision', // avg rank 3.67: holidays-274 mAP 0.895, coco-216 mAP 0.505, NMI 0.758
  'sapiens2-int8', // avg rank 5.00: holidays-274 mAP 0.739, coco-216 mAP 0.149, NMI 0.643
  'sapiens2-fp16', // not run: same model as sapiens2-int8
  'sapiens2-fp32', // not run: same model as sapiens2-int8
  'openai' // not benchmarked
]

/** Rank on the benchmark, 1 = best: quality as in MODEL_RANK, speed by seconds per photo. */
export const MODEL_BADGES: Partial<Record<ModelVariant, { speed: number; quality: number }>> = {
  embeddinggemma2: { speed: 2, quality: 1 }, // 1.67 s/photo
  'chrome-ai': { speed: 5, quality: 2 }, // 20.14 s/photo
  nomic: { speed: 1, quality: 3 }, // 0.36 s/photo
  'smolvlm2-vision': { speed: 3, quality: 4 }, // 1.68 s/photo
  'sapiens2-int8': { speed: 4, quality: 5 } // 3.75 s/photo
}

/** Best first by how well the 2D map keeps real neighbours (average rank). */
export const PROJECTION_RANK: readonly ProjectionMethod[] = [
  'TSNE', // avg rank 1.22
  'TriMap', // avg rank 1.82
  'UMAP', // avg rank 3.37
  'ISOMAP', // avg rank 5.02
  'PCA', // avg rank 5.13
  'MDS', // avg rank 5.36
  'SAMMON', // avg rank 6.17
  'LLE' // avg rank 7.91
]
